import React from 'react'

import MapaUm from './MapaGoogle'
import { IMapaLoteProps } from './MapaLote.types'

const MapaLote: React.FC<IMapaLoteProps> = ({ origem, destino }) => {
  return <MapaUm origem={origem} destino={destino} />
}

export default MapaLote
